// src/reducers/franchiseReducer.js

import {
  // Create
  CREATE_FRANCHISE_REQUEST,
  CREATE_FRANCHISE_SUCCESS,
  CREATE_FRANCHISE_FAIL,
  // Read
  GET_ALL_FRANCHISES_REQUEST,
  GET_ALL_FRANCHISES_SUCCESS,
  GET_ALL_FRANCHISES_FAIL,
  // Update
  EDIT_FRANCHISE_REQUEST,
  EDIT_FRANCHISE_SUCCESS,
  EDIT_FRANCHISE_FAIL,
  // Delete
  DELETE_FRANCHISE_REQUEST,
  DELETE_FRANCHISE_SUCCESS,
  DELETE_FRANCHISE_FAIL,
  // Context
  SELECT_FRANCHISE_REQUEST,
  SELECT_FRANCHISE_SUCCESS,
  SELECT_FRANCHISE_FAIL,
  SET_FRANCHISE_CONSOLE_REQUEST,
  SET_FRANCHISE_CONSOLE_SUCCESS,
  SET_FRANCHISE_CONSOLE_FAIL,
  GET_ACCESSIBLE_FRANCHISES_REQUEST,
  GET_ACCESSIBLE_FRANCHISES_SUCCESS,
  GET_ACCESSIBLE_FRANCHISES_FAIL,
  // Franchise data
  GET_FRANCHISE_STOCK_REQUEST,
  GET_FRANCHISE_STOCK_SUCCESS,
  GET_FRANCHISE_STOCK_FAIL,
  GET_FRANCHISE_SALES_REQUEST,
  GET_FRANCHISE_SALES_SUCCESS,
  GET_FRANCHISE_SALES_FAIL,
  // Clear
  CLEAR_ERRORS,
} from "../constants/userConstants";

const initialState = {
  // lists
  franchises: [],
  accessibleFranchises: [],

  // selected
  selectedFranchise: null,
  selectedConsole: null,

  // data
  stock: [],
  sales: [],

  // status flags
  loading: false,
  error: null,
  message: null,

  // create
  isCreated: false,

  // select-franchise flow
  selectLoading: false,
  selectError: null,
};

export default function franchiseReducer(state = initialState, action) {
  switch (action.type) {
    // Create
    case CREATE_FRANCHISE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        isCreated: false,
        message: null,
      };
    case CREATE_FRANCHISE_SUCCESS:
      return {
        ...state,
        loading: false,
        isCreated: true,
        message: "Franchise created successfully.",
        franchises: state.franchises.some(f => f._id === action.payload._id)
          ? state.franchises
          : [...state.franchises, action.payload],
        selectedFranchise: action.payload,
      };
    case CREATE_FRANCHISE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Read
    case GET_ALL_FRANCHISES_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_ALL_FRANCHISES_SUCCESS:
      return { ...state, loading: false, franchises: action.payload };
    case GET_ALL_FRANCHISES_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Update
    case EDIT_FRANCHISE_REQUEST:
      return { ...state, loading: true, error: null, message: null };
    case EDIT_FRANCHISE_SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        loading: false,
        message: "Franchise updated successfully.",
        franchises: state.franchises.map(f =>
          f._id === updated._id ? updated : f
        ),
        selectedFranchise:
          state.selectedFranchise && state.selectedFranchise._id === updated._id
            ? updated
            : state.selectedFranchise,
      };
    }
    case EDIT_FRANCHISE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Delete
    case DELETE_FRANCHISE_REQUEST:
      return { ...state, loading: true, error: null, message: null };
    case DELETE_FRANCHISE_SUCCESS: {
      const deletedId = action.payload; // assume payload = id string
      return {
        ...state,
        loading: false,
        message: "Franchise deleted successfully.",
        franchises: state.franchises.filter(f => f._id !== deletedId),
        selectedFranchise:
          state.selectedFranchise && state.selectedFranchise._id === deletedId
            ? null
            : state.selectedFranchise,
      };
    }
    case DELETE_FRANCHISE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Select (admin context)
    case SELECT_FRANCHISE_REQUEST:
      return { ...state, selectLoading: true, selectError: null };
    case SELECT_FRANCHISE_SUCCESS: {
      const payloadFranchise = action.payload.franchise || action.payload;
      return {
        ...state,
        selectLoading: false,
        selectedFranchise: payloadFranchise,
      };
    }
    case SELECT_FRANCHISE_FAIL:
      return { ...state, selectLoading: false, selectError: action.payload };

    // Console
    case SET_FRANCHISE_CONSOLE_REQUEST:
      return { ...state, loading: true, error: null };
    case SET_FRANCHISE_CONSOLE_SUCCESS:
      return { ...state, loading: false, selectedConsole: action.payload };
    case SET_FRANCHISE_CONSOLE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Accessible
    case GET_ACCESSIBLE_FRANCHISES_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_ACCESSIBLE_FRANCHISES_SUCCESS:
      return { ...state, loading: false, accessibleFranchises: action.payload };
    case GET_ACCESSIBLE_FRANCHISES_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Stock
    case GET_FRANCHISE_STOCK_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_FRANCHISE_STOCK_SUCCESS:
      return { ...state, loading: false, stock: action.payload };
    case GET_FRANCHISE_STOCK_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Sales
    case GET_FRANCHISE_SALES_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_FRANCHISE_SALES_SUCCESS:
      return { ...state, loading: false, sales: action.payload };
    case GET_FRANCHISE_SALES_FAIL:
      return { ...state, loading: false, error: action.payload };

    // Clear errors/messages
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
        message: null,
        isCreated: false,
        selectError: null,
      };

    default:
      return state;
  }
}
